export interface CustomError extends Error {
  code?: string;
}

const error: CustomError = new Error('Email non valide');

error.code = 'auth/invalid-email';

export const EMAIL_INVALID_ERROR = error;

export const LEGAL_AGE = 18;
